import React from 'react'
import { motion } from 'framer-motion'
import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import styled from '@emotion/styled'

import Card from '@/components/Feature/Elegidos/SimpleCard'
import getData from '@/components/Feature/Elegidos/Data'
import ProcessData from '@/components/Feature/Elegidos/ProcessData'

let animations = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
}

const Main = styled(motion.div)``

const PorPartido = () => {
  const allData = getData()
  const { elegidos } = ProcessData(allData)

  const heroContent = {
    title: 'El Congreso por Partido Político',
    description:
      'A continuación, un desglose por el congreso, por partido político, tanto de los electos como de los senadores en ejercicio.',
  }
  return (
    <Main initial="exit" animate="enter" exit="exit" variants={animations}>
      <Layout>
        <SEO />
        <Card
          {...heroContent}
          elegidos={elegidos}
          grouper="partidoPolitico"
          path="/perfil/por-partido/"
        />
      </Layout>
    </Main>
  )
}

export default PorPartido
